import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

const Markdown = styled.div`
  font-size: 14px;
  color: ${props =>
    props.theme.colors[props.color] || props.theme.colors.neutral7};

  ol,
  ul {
    margin: 8px 0;
  }

  li {
    padding: 0;
  }

  ol {
    li {
      list-style-type: decimal;
      list-style-position: outside;
      margin-left: 30px;
    }
  }

  ul {
    li {
      list-style-type: disc;
      list-style-position: outside;
      margin-left: 30px;
    }
  }

  a {
    color: ${props => props.theme.colors.seedlyBlue};
    text-decoration: underline;
  }
`;

const Anchor = styled.a`
  &:link,
  &:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }
  &:hover {
    text-decoration: underline;
  }
`;

const Link = props => {
  return (
    <Anchor href={props.href} rel="ugc noopener noreferrer" target="_blank">
      {props.children}
    </Anchor>
  );
};

const RewardMarkdown = props => {
  const { color = 'neutral7' } = props;

  return (
    <Markdown color={color}>
      <ReactMarkdown plugins={[breaks]} renderers={{ link: Link }}>
        {props.children}
      </ReactMarkdown>
    </Markdown>
  );
};

export default RewardMarkdown;
